export default "__VITE_ASSET__CqlZ5eva__"